'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PageAndMenu = require('./PageAndMenu');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _Page = function _Page(props) {
	return _react2.default.createElement(
		_PageAndMenu.Context.Consumer,
		null,
		function (context) {
			return _react2.default.createElement(Page, _extends({}, props, { menuIsExpanded: context.menuIsExpanded }));
		}
	);
};

exports.default = _Page;

// // when adjusting this transition time also adjust it in styles/xs-m.scss
// const menu_transition_duration = 0 // 210 // milliseconds

var Page = (_temp = _class = function (_Component) {
	_inherits(Page, _Component);

	function Page() {
		_classCallCheck(this, Page);

		return _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).apply(this, arguments));
	}

	_createClass(Page, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    menuIsExpanded = _props.menuIsExpanded,
			    rest = _objectWithoutProperties(_props, ['menuIsExpanded']);

			// className={ classNames(className,
			// {
			// 	'rrui__page--menu-overlay' : menuIsExpanded
			// }) }>

			// Slideout menu pushes the page to the right
			// const page_style_with_menu_expanded = { transform: `translate3d(${this.state.menu_width}px, 0px, 0px)` }
			//
			// style={ this.state.show_menu ? { ...style.page, ...page_style_with_menu_expanded } : style.page }
			//
			// `translate3d` animation won't work:
			// http://stackoverflow.com/questions/14732403/position-fixed-not-working-for-header/14732712#14732712

			// style={style.page}

			return _react2.default.createElement('div', rest);
		}
	}]);

	return Page;
}(_react.Component), _class.propTypes = {
	menuIsExpanded: _propTypes2.default.bool.isRequired
}, _temp);

// const style =
// {
// 	page:
// 	{
// 		position : relative
// 		z-index  : 0
// 		transition-duration : ${menu_transition_duration}ms
// 	}
// }
//# sourceMappingURL=Page.js.map